<template>
    <div class="reviews d-flex flex-row row m-5">
        <div class="d-flex col-12 col-sm-6 col-md-3 flex-column p-2 review"
                v-for="(review, i) in reviews" :key="i">
            <div class="d-block star-rating">⭐⭐⭐⭐⭐</div>
            <div class="d-flex flex-row mx-auto">
                <img class="d-flex flex-column" :src="review.profilePhotoUrl" />
                <div class="d-flex align-self-center ms-2">
                    <b class="review-name">{{ review.authorName }}</b>
                </div>
            </div>
            <div class="review-text">
                <b>&ldquo;</b>{{ review.text }}<b>&rdquo;</b>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['reviews'],
        data: function () {
            return {};
        },
        methods: {
        }
    }
</script>